<script>
import Segment from '../../../../../Segment';
import router from '../../../../../router';

export default {
  name: 'SubscribeClickHandler',
  methods: {
    subscribeClicked() {
      Segment.trackUserInteraction('SubscriptionSettings_SubscribeButtonClicked', { subscriptionState: this.subscriptionState });
      router.push({ path: '/subscription' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/SubscribeClickHandler.vue